import { Link } from 'react-router-dom';
import useBlur from '../hooks/useBlur';
import '../styles/Nav.css';

function Nav() {
    useBlur('nav');
    
    return (
        <nav>
            <ol>
                <li>
                    <Link to='/puzzlehunt'>
                        <span className='main-topic'>퍼즐 헌트</span>
                    </Link>
                </li>
                <li>
                    <Link to='/puzzlehunt/general'>
                        <span className='sub-topic'>정규 퍼즐 헌트</span>
                    </Link>
                </li>
                <li>
                    <Link to='/puzzlehunt/mini'>
                        <span className='sub-topic'>미니 퍼즐 헌트</span>
                    </Link>
                </li>
                <li>
                    <Link to='/sudoku'>
                        <span className='main-topic'>스도쿠</span>
                    </Link>
                </li>
                <li>
                    <Link to='/sudoku/list/'>
                        <span className='sub-topic'>정규 스도쿠</span>
                    </Link>
                </li>
                <li>
                    <Link to='/sudoku/hunt/'>
                        <span className='sub-topic'>스도쿠 헌트</span>
                    </Link>
                </li>
                <li>
                    <Link to='/crossword'>
                        <span className='main-topic'>십자말풀이</span>
                    </Link>
                </li>
                <li>
                    <Link to='/crossword/general'>
                        <span className='sub-topic'>정규 십자말풀이</span>
                    </Link>
                </li>
                <li>
                    <Link to='/crossword/variant'>
                        <span className='sub-topic'>변형 십자말풀이</span>
                    </Link>
                </li>
                <li>
                    <Link to='/crossword/cryptic'>
                        <span className='sub-topic'>난해한 십자말풀이</span>
                    </Link>
                </li>
                <li>
                    <Link to='/offline'>
                        <span className='main-topic'>오프라인</span>
                    </Link>
                </li>
                <li>
                    <Link to='/offline/puzzleparty'>
                        <span className='sub-topic'>퍼즐 파티</span>
                    </Link>
                </li>
            </ol>
        </nav>
    );
}

export default Nav;